import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class TornGround extends Floor {
	static key = "TornGround";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): TornGround {
		const f = new TornGround(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
